// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questions-board {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0 24px 24px;
  flex: 1;
}
.questions-board h4 {
  margin-top: 0;
}
.questions-board__add-new {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.questions-board__add-new .button {
  -ms-user-select: none;
  -webkit-user-select: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  height: 2.45rem;
  text-align: center;
  user-select: none;
  vertical-align: middle;
  margin-top: 0.5rem;
  min-width: 180px;
}
@media (max-width: 1366px) {
  .questions-board__add-new .button {
    font-size: 0.675rem;
    height: 1.75rem;
    min-width: 100px;
    margin-top: 0;
  }
}
.questions-board__add-new .button:hover, .questions-board__add-new .button:focus, .questions-board__add-new .button:active {
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
}
.questions-board__selected-questions {
  padding: 1rem;
  background-color: #fff;
  border-radius: 0.4rem;
  min-height: 12rem;
  position: relative;
}
@media (max-width: 1366px) {
  .questions-board__selected-questions {
    padding: 0.2rem;
  }
}
.questions-board__selected-questions .empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.questions-board__columns-container {
  flex: 1;
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
}
.questions-board__column {
  display: flex;
  flex-direction: column;
}
.questions-board__column:nth-child(1) {
  flex: 1 0 30%;
}
.questions-board__column:nth-child(2) {
  flex: 1 0 calc(40% - 24px);
}
.questions-board__column:nth-child(3) {
  flex: 1 0 30%;
}
.questions-board__column-title-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 10px;
}
.questions-board__column-title-container > *:first-child {
  margin-right: 10px;
}
.questions-board__items-container {
  top: 2px;
  position: absolute;
  padding: 10px;
  width: 100%;
  overflow: scroll;
  max-height: 100% !important;
}
.questions-board__inner-column {
  position: relative;
  flex: 1;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff;
  border-radius: 0.6rem;
  box-shadow: 5px 8px 24px 5px rgba(208, 216, 243, 0.6);
}
.questions-board .ant-tabs {
  width: 100%;
}
.questions-board__meeting-container {
  position: relative;
  display: flex;
  flex: 1;
}
.questions-board__meeting-container > *:last-child {
  flex: 1;
}
.questions-board__meeting-wrapper {
  height: 100%;
  display: flex;
}
.questions-board__meeting-wrapper > *:last-child {
  flex: 1;
}
.questions-board__users-questions-container {
  position: relative;
  overflow: hidden;
}
.questions-board__users-questions-wrapper {
  position: absolute;
  overflow-y: scroll;
  max-height: calc(100% - 55px);
  width: calc(100% - 35px);
  top: 55px;
}
.questions-board__collapse-question-button {
  position: absolute;
  z-index: 99;
  right: 0px;
  top: -10px;
}`, "",{"version":3,"sources":["webpack://./src/components/functional/QuestionsBoard/QuestionsBoard.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,OAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;AAAR;AAEQ;EACI,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAAZ;AAEY;EAZJ;IAaQ,mBAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;EACd;AACF;AACY;EAGI,sCAAA;EACA,2BAAA;AADhB;AAMI;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AAJR;AAMQ;EAPJ;IAQQ,eAAA;EAHV;AACF;AAKQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAHZ;AAOI;EACI,OAAA;EACA,aAAA;EACA,iBAAA;EACA,SAAA;AALR;AAQI;EACI,aAAA;EACA,sBAAA;AANR;AAQQ;EACI,aAAA;AANZ;AASQ;EACI,0BAAA;AAPZ;AAUQ;EACI,aAAA;AARZ;AAYI;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,oBAAA;AAVR;AAYQ;EACI,kBAAA;AAVZ;AAcI;EACI,QAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAZR;AAeI;EACI,kBAAA;EACA,OAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qDAAA;AAbR;AAgBI;EACI,WAAA;AAdR;AAiBI;EACI,kBAAA;EACA,aAAA;EACA,OAAA;AAfR;AAiBQ;EACI,OAAA;AAfZ;AAmBI;EACI,YAAA;EACA,aAAA;AAjBR;AAmBQ;EACI,OAAA;AAjBZ;AAqBI;EACI,kBAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,wBAAA;EACA,SAAA;AApBR;AAuBI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AArBR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
